module.exports = __webpack_public_path__ + "img/vertical_6_6_7016.3ea9a062.png";